import { useState, useEffect } from "react";
import { v4 as uuid } from 'uuid'
import $ from 'jquery'
import ReCAPTCHA from "react-google-recaptcha";
import DOMPurify from "dompurify";

import Parser from 'html-react-parser';

// Sass
 import '../../../../Sass/includes/Components/modules/CE41.sass'

import { RegisterRequestService } from 'actions/HttpCalls'
import { HttpClient } from 'actions/HttpClient'
import { validForm } from 'constants/validFuntions'

const httpClient = new HttpClient();
const registerRequestService = new RegisterRequestService(httpClient);

const STATUS = {
	STEPS: "steps",
	SUCCESS: "success",
	APPLICATION: "application",

}

var today = new Date();
var maxDate = `${today.getFullYear() + 2}-${String(today.getMonth() + 3).padStart(2,'0')}-${String(today.getDate()).padStart(2,'0')}`
var minDate = `${today.getFullYear() - 93}-${String(today.getMonth() + 3).padStart(2,'0')}-${String(today.getDate()).padStart(2,'0')}`
const SITE_KEY = "6LcrQLEeAAAAAP9jjwF8j2Wc0kGl6bxm3DcKd56c";


function getStepInfo(stepIndex, dataConfig) {

    switch (stepIndex) {
        case 0:
            return <div className="ce41BoxStepsInfo">
                        <i className="ico-archive"></i>
                        {dataConfig?.title_BOX_1 && <h3>
                            <span>Paso 1 </span>
                            {Parser(dataConfig.title_BOX_1)}
                        </h3>}
                        {dataConfig?.description_BOX_1 && <p>{Parser(dataConfig.description_BOX_1)}</p>}
                    </div>;
        case 1:
             return <div className="ce41BoxStepsInfo">
                        <i className="ico-archive"></i>
                        {dataConfig?.title_BOX_3 && <h3>
                            <span>Paso 2 </span>
                            {Parser(dataConfig.title_BOX_3)}
                        </h3>}
                        {dataConfig?.description_BOX_3 && <p>{Parser(dataConfig.description_BOX_3)}</p>}
                    </div>;
        case 2:
            return <div className="ce41BoxStepsInfo">
                        <i className="ico-file-text"></i>
                        {dataConfig?.title_BOX_5 && <h3>
                            <span>Paso 3 </span>
                            {Parser(dataConfig.title_BOX_5)}
                        </h3>}
                        {dataConfig.description_BOX_5 && <p>{Parser(dataConfig.description_BOX_5)}</p>}
                    </div>;
        default:
            return "No Content";
    }
}

function getStepContent(setOtherParentTitular, otherParentTitular,setParentescoTitular, parentescoTitular, cedulaTitular, setCedulaTitular, setNombreTitular, nombreTitular, familyName, setFamilyName,familyContact, setNumberValidContactFamily, stepIndex, dataConfig, txtTerms5, dataOfBanks, dataPlanes, dataDocumentTypes, dataDepartments, dataEntities, dataOperators, 
		localTelefono, validateOnlyNumbersComparador,
		nameUser,
		setNameUser,
		phoneUser,
		setNumberValid,
		idDocumentType,
		setIdDocumentType,
		noDocument,
		setNumberValidDocument,
		emailUser,
		setEmailUser,
		birthDateUser,
		setBirthDateUser,
		expediDataUser,
		setExpediDataUser,
		nit,
		setNit,
		insertSimCar,
		setInsertSimCar,
		nombreEmpleado,
		setNombreEmpleado,
		cedulaEmpleado,
		setCedulaEmpleado,
		camaraComercio,
		setCamaraComercio,
		addressUser,
		setAddressUser,
		cityUser,
		setCityUser,
		idDeparment,
		setIdDeparment,
		barrioUser,
		setBarrioUser,
		parentesco,
		setParentesco,
		otherParent,
		setOtherParent,
		idPlanSelected,
		setIdPlanSelected,
		typeModalidad,
		radiosModality,
		operatorSelected, setOperatorSelected,
		entitySelected, setEntitySelected,
		fiAutDescuentoNom, setFiAutDescuentoNom,
		fiAceptaContrato, setFiAceptaContrato,
		setCaptchaValue,
		fiFactElec, setFiFactElec,
		handleSubmit,
		idBanco,
	) {

	const optionsDocumentType = dataDocumentTypes?.length ? dataDocumentTypes.map((docT, index) => (
		<option key={uuid()} value={docT.fi_id} >{docT.fc_descripcion}</option>
	)) : null


	switch (stepIndex) {
		case 0:
			return <div className="ce41BoxProcessInner">
					<form onSubmit={handleSubmit} name="formUserInfo">
					<div className="fsTwoCols">
						<fieldset>
							<label>Nombre y Apellidos </label>
							<input type="text" value={nameUser}  onChange={(e) => {const regex = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]*$/;  if (regex.test(e.target.value)) {setNameUser(e.target.value);} }} name="nameUser" id="nameUser" placeholder="Escriba su nombre" required/>
						</fieldset>
						{(idBanco === 5 || idBanco === 7) ? (
  									<fieldset>
    									<label>Número de celular a incluir en el convenio</label>
    									<input type="text" value={phoneUser} onChange={e => setNumberValid(e.target.value)} maxLength={10} minLength={10} name="phoneUser" id="phoneUser" placeholder="Escriba su número de telefono" required/>
  									</fieldset>
						) : (
	  								<fieldset>
    									<label>Número de Celular</label>
    										<input type="text" value={phoneUser} onChange={e => setNumberValid(e.target.value)} maxLength={10} minLength={10} name="phoneUser" id="phoneUser" placeholder="Escriba su número de telefono" required/>
                                    </fieldset>
						)}

					</div>
					<div className="fsTwoCols">
						<fieldset>
							<label>Tipo de Documento</label>
							<span className="select">
								<select value={idDocumentType} onChange={e=>{setIdDocumentType(parseInt(e.target.value))}} name='idDocumentType' id='idDocumentType' required>
									<option value="" disabled>Seleccionar</option>
									{optionsDocumentType}
								</select>
							</span>
						</fieldset>
						<fieldset>
							<label>Número de Documento</label>
							<input type="text" value={noDocument} onChange={e=>{setNumberValidDocument(e.target.value)}} maxLength={15} name='noDocument' id='noDocument' placeholder="Escriba el número de identificación" required/>
						</fieldset>
					</div>
					<h3 className="middleTitle">Domicilio</h3>
					<div className="fsTwoCols">
						<fieldset>
							<label>Dirección de Residencia</label>
							<input type="text" value={addressUser} onChange={e=>{setAddressUser(e.target.value)}} maxLength={100} name='addressUser' id='addressUser' placeholder="Escriba su dirección" required/>
						</fieldset>
						<fieldset>
							<label>Ciudad / Municipio</label>
							<input type="text" value={cityUser} onChange={e=>{setCityUser(e.target.value)}} maxLength={100} name='cityUser' id='cityUser' placeholder="Escriba su ciudad" required/>
						</fieldset>
					</div>
					{ /* Ajuste fecha expedicion */ }
					<div  className="fsTwoCols">
					{dataConfig.visible_INPUT_FECHA_EXPEDICION === 'true' ? (
  						(idBanco === 7 || idBanco === 5 || idBanco === 4) ? (
    						<fieldset>
      							<label>Fecha de expedición de la cédula</label>
      							<input type="date" value={expediDataUser} min={minDate} max={maxDate} onChange={e => setExpediDataUser(e.target.value)} name="expediDataUser" id="expediDataUser" placeholder="Día / Mes / Año" required/>
    						</fieldset>
  					) : (
    					<fieldset>
      						<label>Fecha de Expedición</label>
      						<input type="date" value={expediDataUser} min={minDate} max={maxDate} onChange={e => setExpediDataUser(e.target.value)} name="expediDataUser" id="expediDataUser" placeholder="Día / Mes / Año" required/>
    					</fieldset>
  						)
					) : null}

					    {
							dataConfig.visible_INPUT_CAMARA_COMERCIO  === 'true' ?
								<fieldset>
									<label>Cámara de comercio</label>
									<input type="text" value={camaraComercio} onChange={e=>{setCamaraComercio(e.target.value)}} maxLength={15} name='camaraComercio' id='camaraComercio' placeholder="Cámara de comercio"required/>
								</fieldset>
							:null
						}
						
					</div>
					{
						dataOfBanks[0]?.fc_descripcion.toLowerCase().indexOf("davivienda") > 0 &&
						<>
							<h3 className="middleTitle">Familiares beneficiarios</h3>
							<div className="fsTwoCols">
								<fieldset>
									<label>Selecciona el parentesco</label>
									<span className="select">
										<select value={parentesco} onChange={e=>{setParentesco(e.target.value)}} id="parentesco" name="parentesco" required>
											<option value="" disabled>Seleccionar</option>
											<option value="Padres">Padres</option> 
											<option value="Hijos">Hijos</option> 
											<option value="Hermanos">Hermanos</option> 
											<option value="Cónyuge">Cónyuge</option>
											<option value="otro">Otros: ¿Cuál?</option>
										</select>
									</span>
								</fieldset>
								{
									parentesco === "otro" &&
									<fieldset>
										<label>Otro</label>
										<input type="text" value={otherParent} onChange={e=>{setOtherParent(e.target.value)}} maxLength={100} name='otherParent' id='otherParent' placeholder="" required/>
									</fieldset>
								}
							</div>
                            <div className="fsTwoCols">
                                <fieldset>
                                    <label>Nombre del familiar</label>
                                    <input type="text" value={familyName} onChange={e=>{setFamilyName(e.target.value)}} maxLength={100} name='familyName' id='familyName' placeholder="Escribe el nombre del familiar" required/>
                                </fieldset>
                                <fieldset>
                                    <label>N&uacute;mero de contacto del familiar</label>
                                    <input type="text" value={familyContact} onChange={e=>{setNumberValidContactFamily(e.target.value)}} minLength={10} maxLength={10} name='noContactFamily' id='noContactFamily' placeholder="Escriba el número de contacto del familiar" required/>
                                </fieldset>
                            </div>
						</>
					}
					<input type="submit" id="submitFormUser" style={{display:"none"}} value="Send" />
					</form>
				</div>;
		
		case 1:
			return <div className="ce41BoxProcessInner">
					{radiosModality}
					<div name="errornameModality" id='errornameModality' className="errorField " style={{display: "none"}}>Por favor, seleccione una modalidad</div>
				</div>;
		case 2:
			return <div className="ce41BoxProcessInner">
					<div className="ce41BoxProcessText">
						<h3>{dataConfig.title_BOX_PROCESS_5}</h3>
						{Parser(String(txtTerms5))}
						<div className="ce41BoxProcessChecks">
							<form onSubmit={handleSubmit} name="formUserAuth">
								<label className="checkbox">
									<input 
										type="checkbox"
										name='fiAceptaContrato'
										checked={fiAceptaContrato}
										onChange={(e)=>{setFiAceptaContrato(!fiAceptaContrato)}}
										required
									/>
									<span className="checkmark"></span>
									<span>{dataConfig.check_TEXT_HOGAR}</span>
								</label>
								<label className="checkbox">
									<input 
										type="checkbox"
										name='fiFactElec'
										checked={fiFactElec}
										onChange={(e)=>{setFiFactElec(!fiFactElec)}}
										required
									/>
									<span className="checkmark"></span><span>{dataConfig.text_ACEPT_FACTURA_5}</span>
								</label>
                                <div className="recaptcha-container" style={{ paddingTop: "12px" }}>
								<ReCAPTCHA
									sitekey={SITE_KEY}
									onChange={(value) => {
										console.log("Captcha value:", value);
										setCaptchaValue(value);
										const captchaError = document.querySelector('.recaptcha-container .errorField');
										if (value && captchaError) {
										captchaError.remove(); 
										}
									}}
						         />
								 </div>
								<input type="submit" id="submitFormUserAuth" style={{display:"none"}} value="Send" />
							</form>
						</div>
					</div>
					<div>
						</div>
				</div>;
		default:
			return "No Content";
	}
}


function FormularioHogar(props) {
	const {
		dataConfig,
		txtTerms5,
		dataOfBanks,
		idBanco,
		dataPlanes,
		dataDocumentTypes,
		dataDepartments,
		dataEntities,
		dataOperators,
		dataModalities,
	} = props;

	const cleanHtml = DOMPurify.sanitize(dataConfig.title_GRACIAS);

    const [dataDocumentTypesLocal, setDataDocumentTypesLocal] = useState(dataDocumentTypes);
    useEffect(() => {
        setDataDocumentTypesLocal(current => dataDocumentTypes)
        console.log(dataDocumentTypes, "jdksjflsafjlkas")
    }, [dataDocumentTypes])
	// var
	const [activeStep, setActiveStep] = useState(0);
	const [status, setStatus] = useState(STATUS.STEPS)
	const steps = ["Step1", "Step2", "Step3"];

	
	const [nameUser, setNameUser] = useState('')
	const [phoneUser, setPhoneUser] = useState('')
	const [familyContact, setFamilyContact] = useState('')
	const [familyName, setFamilyName] = useState('')
	const [cedulaTitular, setCedulaTitular] = useState('')
	const [parentescoTitular, setParentescoTitular] = useState('')
	const [otherParentTitular,setOtherParentTitular] = useState('')
	const [nombreTitular, setNombreTitular] = useState('')
	const [idDocumentType, setIdDocumentType] = useState('')
	const [noDocument, setNoDocument] = useState('')
	const [emailUser, setEmailUser] = useState('')
	const [birthDateUser, setBirthDateUser] = useState('')
	const [expediDataUser, setExpediDataUser] = useState('')
	const [nombreEmpleado, setNombreEmpleado] = useState('')
	const [cedulaEmpleado, setCedulaEmpleado] = useState('')
	const [insertSimCar, setInsertSimCar] = useState('')
	const [nit, setNit] = useState('')
	const [camaraComercio, setCamaraComercio] = useState ('')
	const [addressUser, setAddressUser] = useState('')
	const [cityUser, setCityUser] = useState('')
	const [idDeparment, setIdDeparment] = useState('')
	const [barrioUser, setBarrioUser] = useState('')
	const [parentesco, setParentesco] = useState('')
	const [otherParent, setOtherParent] = useState('')

	const [idPlanSelected, setIdPlanSelected] = useState('')

	const [typeModalidad, setTypeModalidad] = useState('')
	const [modalitySelected, setModalitySelected] = useState('')

	const [localTelefono, setLocalTelefono] = useState('')
	const [operatorSelected, setOperatorSelected] = useState('')
	const [entitySelected, setEntitySelected] = useState('')

	const [idSolicitud, setIdSolicitud] = useState(0)
	const [disabledContinua, setDisabledContinua] = useState(false)

	const [fiAceptaContrato, setFiAceptaContrato] = useState(false)
	const [fiFactElec, setFiFactElec] = useState(false)
	const [fiAutDescuentoNom, setFiAutDescuentoNom] = useState(false)
	const [captchaValue, setCaptchaValue] = useState(null);


	useEffect(()=>{
		console.log("prevActiveStep", activeStep)
		if(activeStep === 0){
			validForm('formUserInfo')
		}
		if(activeStep === 1){
			// validForm('formPlanDiscountNom')
			// validForm('formUserOfTypeModality')

		}
		if(activeStep === 2){
			validForm('formUserOfTypeModality')
		}
		if(activeStep === 3){
			validForm('formUserAuth')
		}
	})

	// Fuctions
	const handleNext = () => {
		let next = true
		var objectsErrors = []

		if(activeStep === 0){
			$('#submitFormUser').trigger( "click" );
			objectsErrors = $("span.errorField");
			if (objectsErrors?.length){
				next = false
			}
		}
		if(activeStep === 1){
			$('#errornamePlan').hide()
			if(typeModalidad === ''){
				$('#errornameModality').show()
				next = false
			}
		}
        
		if(next){
			setActiveStep((prevActiveStep) => prevActiveStep + 1);
		}
	};

	const handleBack = () => {
		setActiveStep((prevActiveStep) => prevActiveStep - 1);
	};
	const handleFinish = () => {
		let finish = true
		var objectsErrors = []

		const formUserAuth = document.querySelector("form[name='formUserAuth']");
		if (!formUserAuth.checkValidity()) {
			formUserAuth.reportValidity();    
			return;          // show bubbles
		}
		
		if (!captchaValue) {
			const captchaElement = document.querySelector('.recaptcha-container');
			if (captchaElement) {
				let captchaError = captchaElement.querySelector('.errorField');
				if (!captchaError) {
					captchaError = document.createElement('span');
					captchaError.className = 'errorField';
					captchaError.textContent = "Completa el captcha";
					captchaElement.appendChild(captchaError);
				}
			}
		} else {
			const captchaError = document.querySelector('.recaptcha-container .errorField');
			if (captchaError) {
				captchaError.remove();
			}
		}
		setDisabledContinua(true)
		if(activeStep === 2){
			$('#submitFormUserAuth').trigger( "click" );
			objectsErrors = $("span.errorField");
			if (objectsErrors?.length){
				finish = false
				setDisabledContinua(false)
			}
		}
		if(finish){
			submintFormReques()
		}
		// setStatus(STATUS.SUCCESS);
	};
	const handleAplication = () => {
		// setStatus(STATUS.APPLICATION);
		window.location.reload();
	};

	const handleSubmit = event => {
		console.log('handleSubmit ran');
		event.preventDefault(); // 👈️ prevent page refresh
	};

	function validateOnlyNumbersComparador(e) {
        // clearClassStatusPlanComparador()
        let regex = /^[0-9\b]+$/;
        let inputVal = e.target.value
        if ( inputVal === '' || (regex.test(inputVal) && (inputVal.startsWith("3"))) ) {
            // console.log("numberssssssssssssssssssssss::::::" + inputVal)
            setLocalTelefono(inputVal)
        }
    }

	async function submintFormReques(){
		var entidad = entitySelected;
		
		if(entitySelected === '') {
			entidad =  dataEntities[0].fi_id;
			setEntitySelected(dataEntities[0].fi_id)
		}		
		console.log('entidad:::::::', entidad);
		const dataBody ={
			"fc_nombres" : nameUser,
			"fc_telefono" : phoneUser,

			"fi_tipo_doc" : idDocumentType,
			"fc_num_doc" : noDocument,
			
			"fc_direccion_res" : addressUser,
			"fc_ciudad" : cityUser,
			"fc_parentesco" : parentesco === "otro" ? otherParent : parentesco,
            "fc_nombre_familiar" : familyName,
            "fc_numero_familiar" : familyContact,
			"fi_modalidad" : modalitySelected,
            "fi_banco" :  idBanco,
			"fi_acepta_contrato" : fiAceptaContrato ? 1 : 0,
			"captchaResponse" : captchaValue,
			"fc_nombre_titular" : nombreTitular,
			"fc_cedula_titular" : cedulaTitular,
			"fc_parentesco_titular" : parentescoTitular === "otro" ? otherParentTitular: parentescoTitular,
		}
		var jsonSendData = JSON.stringify(dataBody);
		const RegistraSolicitud = await registerRequestService.RegisterRequestItemHome(jsonSendData);
		console.log("submintFormReques ", RegistraSolicitud)
		if(RegistraSolicitud){
			setIdSolicitud(parseInt(RegistraSolicitud))
			setStatus(STATUS.SUCCESS);
		}else{
			
			setDisabledContinua(false)
			// setStatus(STATUS)
		}
	}

	const radiosModality = dataModalities?.length ? dataModalities.filter(dataModal => dataModal.fc_tipo_servicio === "HOG").map((mod, index)=>(
		<div className="ce41BoxRadio ce41BoxRadio2" key={uuid()}>
			<input 
				type="radio"
				name="rad1"
				value={mod.fc_titulo} 
				onChange={e=>{setTypeModalidad(mod.fc_titulo); setModalitySelected(parseInt(mod.fi_id))}}
				checked={mod.fi_id === modalitySelected ? true : false}
			/>
			<span className="checkbg"></span>
			<span className="checkmark"></span>
			<div className="ce41BoxRadioInner">
				<h3>{mod.fc_titulo}</h3>
				{
					mod?.fc_descripcion &&
					<p>
						{mod?.fc_descripcion}hola
					</p>
				}
			</div>
			<div className="ce41BoxRadioPicture">
				<i className={`${mod.fc_clase_icono}`}></i>
			</div>
		</div>
	)) : null;

	const setNumberValid = value => {
        if (/^[0-9]+$/.test(value) !== true && value.length > 0) {
            return;
        }
        if (value === '' || value.startsWith("3")) {
            setPhoneUser(value)
        } else{
			return;
        }
    }

    const setNumberValidContactFamily = ( value ) => {
        debugger
        if (/^(?:|6|3\d*|60\d*)$/.test(value)) {
            setFamilyContact(value);
            }

    }

	const setNumberValidDocument = value => {
        if (/^[0-9]+$/.test(value) !== true && value.length > 0) {
            return;
        }
        setNoDocument(value)
    }


	console.log("idBanco:Toma Ajustes Con Fecha de Hoy Ajuste Campo ::::::::::::" + idBanco);
	return (
		<section className="ce41">
			{ status === STATUS.STEPS ? 
				<div className="container">
					<div className="ce41Title">
						<h2>{dataConfig.title_CONTENT}</h2>
						<p>{dataConfig.description_CONTENT}</p>
					</div>
					<div className="ce41Box">
						<div className="ce41BoxSteps">
							{getStepInfo(activeStep, dataConfig)}
							<div className="ce41BoxStepsIndicator" style={{width: "fit-content"}}>
								<span className={activeStep >= 0 ? "active" : "normal"}>&nbsp;</span>
								<span className={activeStep >= 1 ? "active" : "normal"}>&nbsp;</span>
								<span className={activeStep === 2 ? "active" : "normal"}>&nbsp;</span>
							</div>
						</div>
						<div className="ce41BoxProcess">
							{
								getStepContent(
                                    setOtherParentTitular, otherParentTitular,
                                    setParentescoTitular, parentescoTitular,
                                    cedulaTitular, setCedulaTitular, setNombreTitular, nombreTitular,
                                    familyName,
                                    setFamilyName,
                                    familyContact,
                                    setNumberValidContactFamily,
									activeStep,
									dataConfig,
									txtTerms5,
									dataOfBanks,
									dataPlanes,
									dataDocumentTypesLocal,
									dataDepartments,
									dataEntities,
									dataOperators,
									localTelefono,
									validateOnlyNumbersComparador,
									nameUser,
									setNameUser,
									phoneUser,
									setNumberValid,
									idDocumentType,
									setIdDocumentType,
									noDocument,
									setNumberValidDocument,
									emailUser,
									setEmailUser,
									birthDateUser,
									setBirthDateUser,
									expediDataUser,
									setExpediDataUser,
									nit,
									setNit,
									insertSimCar,
									setInsertSimCar,
									nombreEmpleado,
									setNombreEmpleado,
									cedulaEmpleado,
									setCedulaEmpleado,
									camaraComercio,
									setCamaraComercio,
									addressUser,
									setAddressUser,
									cityUser,
									setCityUser,
									idDeparment,
									setIdDeparment,
									barrioUser,
									setBarrioUser,
									parentesco,
									setParentesco,
									otherParent,
									setOtherParent,
									idPlanSelected,
									setIdPlanSelected,
									typeModalidad,
									radiosModality,
									operatorSelected, setOperatorSelected,
									entitySelected, setEntitySelected,
									fiAutDescuentoNom, setFiAutDescuentoNom,
									fiAceptaContrato, setFiAceptaContrato,
									setCaptchaValue,
									fiFactElec, setFiFactElec,
									handleSubmit,
									idBanco,

								)
							}
						</div>
					</div>
					<div className={activeStep === 0 ? "ce41Buttons right" : "ce41Buttons"}>
						{activeStep === 0 ? "" : <button className="btn btnNegro" onClick={handleBack}>Regresar</button>}
						{activeStep < (steps.length - 1) ? <button className="btn btnPrimario" onClick={handleNext}>Siguiente</button> : ""}
						{/* <button className="btn btnPrimario" onClick={handleNext}>
							{activeStep === steps.length - 1 ? "Finalizar" : "Siguiente"}
						</button> */}
						{
						activeStep === steps.length - 1 ?
							<button className="btn btnPrimario" onClick={handleFinish} disabled={disabledContinua} >{disabledContinua ? "Enviando..." : "Finalizar"}</button>
							: ""
						}
					</div>
				</div>
				:""
			}
			{ status === STATUS.SUCCESS ? 
				idSolicitud!==-208?
				<>
					<div className="container">
						<div className="ce41SuccesTitle">
							<i className="ico-check-circle"></i>
							<h2 className="h2">
								Has finalizado tu proceso exitosamente
							</h2>
						</div>
						<div className="ce41SuccesBox">
							<div className="ce41SuccesCont">
								{
								 idBanco &&
									<p 
										className="ce41SuccesContTitle"
										dangerouslySetInnerHTML={{ __html: cleanHtml }}
									>
									</p>
										
								}
								
								<p>
									Nuestros canales de atención tomaran tu requerimiento y se comunicaran contigo o tu familiar con el propósito de brindarte la mejor alternativa para la conectividad de tu hogar. 
								</p>
								{
									idSolicitud &&
									<p className="ce41SuccesContTitle">Número de solicitud: {idSolicitud}</p>
								}
							</div>
							<div className="ce41SuccesActions">
								<button className="btn btnPrimario" onClick={handleAplication}>Volver a Inicio</button> 
							</div>
						</div>
					</div>
				</>
				:<>
				<div className="container">
					<div className="ce41SuccesTitle">
						
						<h2 className="h2">
						      Error al procesar la solicitud
						</h2>
					</div>
					<div className="ce41SuccesBox">
						<div className="ce41SuccesCont">
							
							<p>
							 Has excedido el número de intentos con el número de cédula registrado.
							</p>
						
						</div>
						<div className="ce41SuccesActions">
							<button className="btn btnPrimario" onClick={handleAplication}>Volver a Inicio</button> 
						</div>
					</div>
				</div>
			     </>
				:""
			}
		
		</section>
		
	)
	
}

export default FormularioHogar